export const AnalyticsTab = () => (
  // TODO: Implement analytics functionality
  <div className="flex h-full w-full" />
);
